import { Instance, types } from 'mobx-state-tree';

import RubricLevel from './RubricLevel';

const RubricCriterion = types.model('RubricCriterion', {
	id: types.identifierNumber,
	title: types.string,
	description: types.string,
	grade: types.maybeNull(types.number),
	rubricLevels: types.array(RubricLevel),
});

export default RubricCriterion;

export interface IRubricCriterionModel extends Instance<typeof RubricCriterion> {}
